import { equalCols } from '../functions';

$(document).ready(function() {

	if ($('.boxes-about-us-wrapper').length > 0) {
		$('.boxes-about-us-row').each(function(elem) {
			let id = $(this).data('id');
			equalCols('.equal-height-' + id);
		});
	}
	if ($('.ritchtext-template-1').length > 0) {
		if($(window).width() > 990) {
			equalCols('.equal-height');
		}
	}

    $('.btn_cookies').click(function() {
        var values;
        $.ajax({
            type: "GET",
            url: baseURL + "/accept-cookies-policy",
            data: values,
            success: function(html) {
                $('.box_cookies').hide();
            }
        });
    });

	$('.form-customer .form-check').click(function(){
        $('.form-customer .form-check').removeClass("selected");
        $('.form-customer .form-check-input').prop('checked', false);
        $(this).addClass("selected");
        $(this).find(".form-check-input").prop('checked', true);
    });

    $('.form-emailPreference .form-check').click(function(){
        $(this).toggleClass("selected-checkbox");
    });

    $(".hamburger").click(function(){
        $(".menu-mobile").toggleClass("opened");
        $(".overlay-mobile").toggleClass("opened");
        $("body").addClass("overflow");
    });

    $(".menu-mobile .close").click(function(){
        $(".menu-mobile").toggleClass("opened");
        $(".overlay-mobile").toggleClass("opened");
        $("body").removeClass("overflow");
    });

    $(".btn-menu-account").click(function(){
        $(".account-menu-column").addClass("opened");
        $(".overlay-mobile").toggleClass("opened");
    });
    $(".account-menu-column .closebtn").click(function(){
        $(".account-menu-column").removeClass("opened");
        $(".overlay-mobile").toggleClass("opened");
    });


	/*$(document).on('click', '.box-benefit-show-info', function() {
		$('.box-benefit-item').not(this).removeClass('active');
		$(this).toggleClass('active');
	});
	$(document).mouseup(function(e)  {
	    var container = $(".box-benefit-show-info");

	    // if the target of the click isn't the container nor a descendant of the container
	    if (!container.is(e.target) && container.has(e.target).length === 0) {
	        container.removeClass('active');
	    }
	});*/
	$('.box-benefit-show-info').mouseenter(function() {
									$('.box-benefit-item').not(this).removeClass('active');
									$(this).toggleClass('active');
								})
								.mouseleave(function() {
									$('.box-benefit-item').removeClass('active');
								});

	$(document).on('click', '.mobile-has-submenu', function() {
		$(this).parent().find('.mobile-sub-menu').toggleClass('active');
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/javascript.js